import React from 'react';

export const Warning = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M20.4713 6.22838C22.0881 3.23848 26.3866 3.26227 27.9702 6.26991L43.5041 35.7716C44.9943 38.6017 42.942 42.0017 39.7435 42.0017H8.25595C5.03672 42.0017 2.98626 38.5617 4.51756 35.73L20.4713 6.22838Z"
      fill="#212121"
    />
    <path
      d="M20.4713 6.22838C22.0881 3.23848 26.3866 3.26227 27.9702 6.26991L43.5041 35.7716C44.9943 38.6017 42.942 42.0017 39.7435 42.0017H8.25595C5.03672 42.0017 2.98626 38.5617 4.51756 35.73L20.4713 6.22838Z"
      fill="url(#paint0_linear_378174_9765)"
    />
    <path
      d="M24 15C24.6904 15 25.25 15.5596 25.25 16.25V27.75C25.25 28.4404 24.6904 29 24 29C23.3096 29 22.75 28.4404 22.75 27.75V16.25C22.75 15.5596 23.3096 15 24 15ZM24 35C25.1046 35 26 34.1046 26 33C26 31.8954 25.1046 31 24 31C22.8954 31 22 31.8954 22 33C22 34.1046 22.8954 35 24 35Z"
      fill="url(#paint1_linear_378174_9765)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_378174_9765"
        x1="10.2499"
        y1="-1.93776"
        x2="34.4523"
        y2="46.5854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCD0F" />
        <stop offset="1" stopColor="#FE8401" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_378174_9765"
        x1="18.6667"
        y1="15"
        x2="28.2744"
        y2="35.4964"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4A4A4A" />
        <stop offset="1" stopColor="#242424" />
      </linearGradient>
    </defs>
  </svg>
);
